

import React, { useEffect, useRef, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine, ResponsiveContainer } from 'recharts';
import moment from 'moment';
import { Box } from '@mui/material';
import { SERIES, INK, axisProps, gridProps, ChartTooltip } from '../chartTheme';

const MIN_CHART_WIDTH = 480;

const BurndownChart = ({burnDownChartData}) => {

const chartRef = useRef(null);
/* the weekend bands are drawn as fat reference lines, so their width has to
   follow the real plot width — this panel now shares its row and is no longer
   the full page wide */
const [chartWidth, setChartWidth] = useState(MIN_CHART_WIDTH);

const [burnDownData ,setBurnDownData]=useState([])
const [TotalStoryPoins,setTotalStoryPoints]=useState(0);
const [backupRemaingWork, setBackupRemainingWork]=useState(0);

useEffect(() => {
  if (burnDownChartData.length > 0) {
    getDatesOftheSprint(burnDownChartData[0]?.startDate, burnDownChartData[0]?.endDate);
    getTotalStoryPoints(burnDownChartData[0]?.issues);
  }
}, [burnDownChartData]);

useEffect(() => {
  const node = chartRef.current;
  if (!node) return undefined;

  const measure = () => setChartWidth(Math.max(node.clientWidth, MIN_CHART_WIDTH));
  measure();

  if (typeof ResizeObserver === 'undefined') {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }
  const observer = new ResizeObserver(measure);
  observer.observe(node);
  return () => observer.disconnect();
}, []);



const getHowmanyWeekOffDays =async(duration , startDate ,endDate)=>{
try{
let DatesArray = await Promise.all(Array.from({length:duration}).map((defaultCurrElem,i)=>{
  let nextDate = new Date(startDate);
  nextDate.setDate(nextDate.getDate() + i);
  return nextDate

}))

let WeekoffDayArray =  DatesArray.filter((eachDate)=>{
  return moment(eachDate).format("ddd") == "Sat" || moment(eachDate).format("ddd") =='Sun'

})

return WeekoffDayArray?.length

}
catch(error){
return 0
}
}


let currentCoordinate = burnDownChartData[0]?.initiallyplannedStoryPoints;
const getActualPlannedData = async (i, day) => {
  try {
    let actualPlannedStoryPoints = burnDownChartData[0]?.initiallyplannedStoryPoints || 0;
    let start = new Date(burnDownChartData[0]?.startDate);
    let end = new Date(burnDownChartData[0]?.endDate);

    const startDate = moment(start);
    const endDate = moment(end);
    const duration = endDate.diff(startDate, "days");

    let WeekOffCount = await getHowmanyWeekOffDays(duration - 1, start, end);
    let totalWorkingDays = duration - WeekOffCount;
    let PlannedWorkPerDay = Math.ceil((actualPlannedStoryPoints || 1) / (totalWorkingDays || 1));

    if (day === 'Sat' || day === 'Sun') {
      if(currentCoordinate<=0){
        return 0
      }
      return currentCoordinate;
    } else {
      currentCoordinate -= PlannedWorkPerDay;
      if(currentCoordinate<=0){
        return 0
      }
      return currentCoordinate;
    }
  } catch (error) {
    // console.log(error.message, 'getActualPlannedData error');
    return 0;
  }
};


const getTotalStoryPoints = async(issues)=>{
 
  try{
let value= issues.map((each)=>{

  return  each?.storyPointEstimate||0
})

let totalStoryPoins =  value.reduce((c,a)=>{
  return c+a
})

setTotalStoryPoints(totalStoryPoins)
  }
  catch(error){

  }
}

const getremainginwork = (date)=>{
  try{

 let requiredObj =   burnDownChartData[0]?.burndowninfo.filter((each)=>{
 
     return moment(each.date).format("MMM DD") == date

    })

    if(requiredObj?.length==0){
      return null
    }
    setBackupRemainingWork(requiredObj?.reverse()[0]?.remainingWork ) 
  
    return requiredObj[0].remainingWork

  }
  catch(error){
console.log(error ,'error ')
  }
}


// let bckupRemainingworkArray =[]
// const getremainginwork = (date)=>{
//   try{
 
//  let requiredObj =   burnDownChartData[0]?.burndowninfo.filter((each)=>{
 
//      return moment(each?.date).format("MMM DD") == date
 
//     })
 
// //console.log(new Date(date) < new Date(burnDownChartData[0]?.burndowninfo[burnDownChartData[0]?.burndowninfo.length-1].date) , "check")
 
 
//     if(requiredObj?.length==0 
//      // && new Date(date) < new Date(burnDownChartData[0]?.burndowninfo[burnDownChartData[0]?.burndowninfo.length-1].date)
//      ){
   
//       return bckupRemainingworkArray[bckupRemainingworkArray.length-1]
//     }
//     bckupRemainingworkArray.push(requiredObj[0].remainingWork)
//     return requiredObj[0].remainingWork
 
//   }
//   catch(error){
// console.log(error ,'error ')
//   }
// }



const getDatesOftheSprint = async(start , end)=>{
  try{
    const startDate = moment(start);
    const endDate = moment(end);
    const duration = endDate.diff(startDate, "days");
   let data = await Promise.all(Array.from({length:duration+1}).map(async(defaultCurrElem ,i)=>{
    let nextDate = new Date(startDate);
    nextDate.setDate(nextDate.getDate() + i);
return  { date: moment(nextDate).format("MMM DD"), remainingWork: getremainginwork(moment(nextDate).format("MMM DD")),actual: await getActualPlannedData(i, moment(nextDate).format("ddd"))  , day:moment(nextDate).format("ddd")}


}))
 setBurnDownData(data)
  }
  catch(error){
    console.log(error?.message)
  }
}


  const bandWidth = chartWidth / (burnDownData?.length || 1);

  return (
    /* it fills whatever column it is given and only scrolls once it would drop
       below a readable width — same pattern as the other two panels */
    <Box sx={{ width: '100%', overflowX: 'auto' }} ref={chartRef}>
      <Box sx={{ minWidth: MIN_CHART_WIDTH }}>
    <ResponsiveContainer width="100%" height={420}>
    <LineChart
      data={burnDownData}
      margin={{ top: 8, right: 32, left: 12, bottom: 5 }}
    >
      <CartesianGrid {...gridProps} />

      <XAxis dataKey="date"
      interval="preserveStartEnd"
      minTickGap={10}
      {...axisProps}
       />
      {burnDownData.map((each, index) => (
       
        (each.day === "Sat" || each.day === "Sun") && (
          <ReferenceLine
            key={index}
            x={each?.date}
            stroke={INK.grid}
            strokeOpacity={1}
            strokeWidth={bandWidth}
            name="week off"
            /* the caption only fits once the band is wide enough to hold it */
            label={
              bandWidth >= 34
                ? {
                    value: 'Week off',
                    position: 'insideTop',
                    fill: INK.muted,
                    fontSize: 10,
                    dy: -2,
                  }
                : undefined
            }
          />
        )
      ))}
      <YAxis
      {...axisProps}
      axisLine={false}
      label={{ value: 'Story points', angle: -90, position: 'insideLeft', fill: INK.muted, fontSize: 12, dy: 44 }}
       tickCount={8}
       width={64}
         />
      <Tooltip
        content={<ChartTooltip />}
        cursor={{ stroke: INK.border, strokeWidth: 1 }}
      />
      <Legend
        iconType="plainline"
        iconSize={18}
        wrapperStyle={{ paddingTop: 12, fontSize: 13, color: INK.secondary }}
      />
      {/* ideal burn-down is a guide, so it stays recessive and dashed — the
          dash is a secondary encoding, identity is never colour-alone */}
      <Line
        type="step"
        dataKey="actual"
        name="Ideal"
        stroke={INK.guide}
        strokeWidth={2}
        strokeDasharray="5 5"
        dot={false}
        activeDot={false}
      />
      <Line
        type="step"
        dataKey="remainingWork"
        name="Remaining work"
        stroke={SERIES[0]}
        strokeWidth={2}
        dot={{ r: 3, strokeWidth: 2, stroke: INK.surface, fill: SERIES[0] }}
        activeDot={{ r: 5, strokeWidth: 2, stroke: INK.surface, fill: SERIES[0] }}
      />
    </LineChart>
    </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default BurndownChart;
